import ImageColumn from './ImageColumn';

export default ImageColumn;
